import { render, staticRenderFns } from "./SampleRequiredTests.vue?vue&type=template&id=2ff0b5e8&scoped=true&"
import script from "./SampleRequiredTests.vue?vue&type=script&lang=js&"
export * from "./SampleRequiredTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0b5e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VChip,VItemGroup})
